import { parsePhoneNumberFromString } from "libphonenumber-js";
const rEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function CancelPolicyValidation(values: any) {
  let errors: any = {};

  if (!values.email) {
    errors.email = "El email es requerido";
  }

  if (!rEmail.test(values.email)) {
    errors.email = "El email ingresado es inválido";
  }

  if (!values.phone) {
    errors.phone = "Campo requerido";
  }

  if (!values.reason_id) {
    errors.reason_id = "Campo requerido";
  }

  if (!/^\d+$/.test(values.phone)) {
    errors.phone = "Solo debes incluir números";
  }

  if (values.phone.length > 10) {
    errors.phone = "Máximo 10 números";
  }

  const phoneNumber = parsePhoneNumberFromString(values.phone, "AR");

  if (!phoneNumber?.isValid()) {
    errors.phone = "El número telefónico ingresado es inválido";
  }
  // console.log(errors);
  return errors;
}
